import { DirectSale } from '@/core/domain/sales/DirectSale/DirectSale.types';
import { Col, Row, Statistic } from 'antd';
import React from 'react';
import { DirectSaleFinancialInstallmentList } from '../DirectSaleFinancialTabs';
import { AccountReceivable } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  valueTotal: number;
  installments?: DirectSaleFinancialInstallmentList[];
  directSale?: DirectSale;
  accountReceivable: AccountReceivable[];
}

const DirectSaleFinancialStatistic: React.FC<Props> = ({
  valueTotal,
  installments,
  directSale,
  accountReceivable,
}) => {
  return (
    <Row
      gutter={[24, 24]}
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 30,
        marginBottom: 30,
      }}
    >
      <Col xs={12} md={12} xl={3}>
        <Statistic
          valueStyle={{ color: 'rgb(160, 206, 51)' }}
          formatter={(value) => formatterPrice(Number(value))}
          value={valueTotal}
          title="Valor Total"
        />
      </Col>

      <Col xs={12} md={12} xl={3}>
        <Statistic
          valueStyle={{ color: 'rgb(160, 206, 51)' }}
          formatter={(value) => formatterPrice(Number(value))}
          value={installments?.reduce(
            (acc, curr) => (acc += curr.realValue ?? 0),
            0,
          )}
          title="Valor Total Líquido"
        />
      </Col>

      <Col xs={12} md={12} xl={3}>
        <Statistic
          valueStyle={{ color: 'rgb(160, 206, 51)' }}
          formatter={(value) => formatterPrice(Number(value))}
          value={installments?.reduce(
            (acc, curr) => (acc += curr.receivableValue ?? 0),
            0,
          )}
          title="Valor a Receber"
        />
      </Col>

      <Col xs={12} md={12} xl={3}>
        <Statistic
          valueStyle={{ color: 'rgb(160, 206, 51)' }}
          formatter={(value) => formatterPrice(Number(value))}
          value={valueTotal}
          title="Valor Negociado"
        />
      </Col>

      <Col xs={12} md={12} xl={3}>
        <Statistic
          valueStyle={{ color: 'rgb(160, 206, 51)' }}
          formatter={(value) => formatterPrice(Number(value))}
          value={
            (directSale?.items.reduce(
              (acc, curr) =>
                (acc +=
                  (curr.unitPrice ?? 0) * (curr.quantity ?? 0) -
                  (curr.discountCurrency ?? 0)),
              0,
            ) ?? 0) -
            (accountReceivable?.reduce(
              (acc, curr) => (acc += curr.installmentValue),
              0,
            ) ?? 0) -
            (valueTotal ?? 0)
          }
          title="Valor a negociar"
        />
      </Col>
    </Row>
  );
};

export default DirectSaleFinancialStatistic;
